import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FlowchartService } from 'src/app/Service/Flowchart/Flowchart.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-FlowchartForm',
  templateUrl: './FlowchartForm.component.html',
  styleUrls: ['./FlowchartForm.component.scss']
})
export class FlowchartFormComponent implements OnInit {

  Token: String = ""
  page: number = 0;
  Procssing: boolean = false
  ProcssingDetail: boolean = false

  modalRef_Delete: any;

  constructor(
    private Flowchart_Service: FlowchartService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }

  DataList_Form: Array<General_Interface> = []
  DataList_FormDetail: Array<General_Interface> = []
  Data_Seleted_Record: General_Interface = Empty_General_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 2199).subscribe(
      data => {
        this.ReadData_Form()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_Form() {
    this.Procssing = true
    this.Flowchart_Service.GetForm(this.Token).subscribe(
      data => {
        this.DataList_Form = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Set_Data_Seleted_Record(item: General_Interface) {
    this.Data_Seleted_Record = item
    this.ReadData_FormDetail()
  }

  Reset_Data_Seleted_Record() {
    this.Data_Seleted_Record = Empty_General_Interface()

  }

  ReadData_FormDetail() {
    this.ProcssingDetail = true
    this.Flowchart_Service.GetFormDetail(this.Token, this.Data_Seleted_Record.id).subscribe(
      data => {
        this.DataList_FormDetail = data
        this.ProcssingDetail = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#region  FormHistory
  modalRef_FormHistory: any;
  modalRef_FormHistory_Delete: any;
  Procssing_FormHistory: boolean = false
  Selected_Chart_FormHistory: General_Interface = Empty_General_Interface()

  FormHistorypage: number = 0;
  Filter_WorkflowTitle: string = ''
  Filter_Area: string = ''

  Change_Filter() {
    this.FormHistorypage = 0
  }

  ReadData_FormHistory() {
    this.Procssing_FormHistory = true

    this.Flowchart_Service.GetActiveWorkflow(this.Token).subscribe(
      data => {
        this.DataList_FormHistory = data
        this.Procssing_FormHistory = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  DataList_FormHistory: Array<General_Interface> = []

  Set_Selected_FormHistory_Record(item: General_Interface) {

    this.modalRef_FormHistory.hide()
    this.Flowchart_Service.AddFormDetail(this.Data_Seleted_Record.id, item.id, this.Token).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage(item.title  + " was added.")
        this.ReadData_FormDetail()
      }
    )

  }

  OnGet_Person_Action(template: TemplateRef<any>) {

    this.modalRef_FormHistory = this.modalService.show(template);
  }

  //#endregion



}
